import axios from 'axios';

// URL du Cloudflare Worker (remplace l'API PHP)
// En production : remplacez par l'URL de votre Worker Cloudflare
// Exemple : 'https://api-efis-worker.VOTRE_SUBDOMAIN.workers.dev'
const API_URL =
  process.env.REACT_APP_API_URL ||
  'https://api-efis-worker.contact-efis2025.workers.dev';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Intercepteur pour déboguer
api.interceptors.request.use(request => {
  console.log(`📡 Envoi requête: ${request.method.toUpperCase()} ${request.baseURL}${request.url}`);
  return request;
});

api.interceptors.response.use(
  response => {
    console.log(`✅ Réponse reçue:`, response.status);
    return response;
  },
  error => {
    console.error(`❌ Erreur API:`, error.message);
    if (error.response) {
      console.error('📦 Status:', error.response.status);
    }
    return Promise.reject(error);
  }
);

// NOTE : Plus d'extension .php — les routes du Worker n'en ont pas besoin
export const projectsAPI = {
  getAll: () => api.get('/projects'),
  getById: (id) => api.get(`/projects?id=${id}`),
  getFeatured: () => api.get('/projects?featured=true'),
};

export const eventsAPI = {
  getAll: () => api.get('/events'),
  getById: (id) => api.get(`/events?id=${id}`),
  getUpcoming: () => api.get('/events?status=upcoming'),
  register: (data) => api.post('/events', { ...data, action: 'register' }),
};

export const teamAPI = {
  getAll: () => api.get('/team'),
};

export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

export const volunteerAPI = {
  apply: (data) => api.post('/volunteers', data),
};

export const newsAPI = {
  getAll: () => api.get('/news'),
  getLatest: () => api.get('/news?limit=3'),
  getById: (id) => api.get(`/news?id=${id}`),
};

export const newsletterAPI = {
  subscribe: (email) => api.post('/newsletter', { email }),
};

export const articlesAPI = {
  getAll: () => api.get('/articles'),
  getByProgram: (programId) => api.get(`/articles?program_id=${programId}`),
  getById: (id) => api.get(`/articles?id=${id}`),
};

export default api;